import { getQueryField } from 'library/ts/utilities/modules/URL';

/** Matches Smart Tag brand enum string values; use with skin/tag Brand enums when applying override. */
export type ForceBrandSlug = 'pplus' | 'plutotv' | 'cbs';

/**
 * Optional QA / embed override: `?forceBrand=pplus`, `pluto` / `plutotv`, or `cbs`.
 * Used when partner params or host CSS are not wired yet (e.g. Pluto test environments).
 *
 * @param url Optional absolute URL; defaults to `window.location.href` when omitted.
 * @returns Matching brand slug, or `undefined` when param absent or invalid.
 */
export function getForceBrandFromQuery( url?: string ): ForceBrandSlug | undefined {
	try {
		const raw = getQueryField( 'forceBrand', url );
		if ( !raw ) {
			return undefined;
		}
		const v = raw.trim().toLowerCase();
		if ( v === 'pplus' ) {
			return 'pplus';
		}
		if ( v === 'pluto' || v === 'plutotv' ) {
			return 'plutotv';
		}
		if ( v === 'cbs' ) {
			return 'cbs';
		}
	} catch {
		// ignore
	}
	return undefined;
}